import React from "react";
import { Flex } from "rebass";

import { SpinnerSVG } from "../svg/SpinnerSVG";

export const DocumentLoading = (
  <Flex
    flex={1}
    justifyContent="center"
    alignItems="center"
    bg="#fff"
    color="sp-blue"
  >
    <SpinnerSVG size={30} />
  </Flex>
);
